// extracted by mini-css-extract-plugin
module.exports = {"container":"livestream-event-CurrentlyLive__container--3iUH4"};